import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CognitoAuthState, cognitoAuthFeatureKey } from './cognito-auth.state';

export const selectCognitoAuthState = createFeatureSelector<CognitoAuthState>(
  cognitoAuthFeatureKey
);

export const selectIsAuthenticated = createSelector(
  selectCognitoAuthState,
  (state) => state.isAuthenticated
);

export const selectUserId = createSelector(
  selectCognitoAuthState,
  (state) => state.userId
);

export const selectIsInProgress = createSelector(
  selectCognitoAuthState,
  (state) => state.isInProgress
);
